export default __webpack_public_path__ + "assets/models/640c74d94666e5cf03160c840f7af17f.glb";